import * as React from "react";
import type { SVGProps } from "react";
const SvgVolumeUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.322 20.627c.27.152.577.233.888.233.1.003.2-.003.3-.02a1.81 1.81 0 0 0 1.17-.73 1.86 1.86 0 0 0 .32-1.25V5.05a1.8 1.8 0 0 0-3.34-1.12l-3.15 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h1.51l3.15 4.06c.162.265.39.485.662.637ZM4 13.93v-4h2a1 1 0 0 0 .79-.39L10 5.44v13l-3.21-4.12a1 1 0 0 0-.79-.39H4Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M17.7 19.93a1 1 0 0 1-.96-.718 1 1 0 0 1 .34-1.062 7.44 7.44 0 0 0 1.18-1.22 8 8 0 0 0-1.18-11.22 1.002 1.002 0 1 1 1.26-1.56 10 10 0 0 1 1.49 14.07 11.001 11.001 0 0 1-1.49 1.49 1 1 0 0 1-.64.22Z"
    />
    <path
      fill="currentColor"
      d="M15 16.93a1 1 0 0 1-.6-1.8c.3-.23.57-.5.8-.8a4 4 0 0 0-.8-5.6 1 1 0 1 1 1.2-1.6 6 6 0 0 1 0 9.6 1 1 0 0 1-.6.2Z"
    />
  </svg>
);
export default SvgVolumeUp;
